var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorBox",staticStyle:{"height":"452px"}},[_c('div',{staticClass:"errorText"},[_c('img',{attrs:{"src":require("../../assets/images/common/tomoon_icon.png")}}),_c('div',[_vm._v("\n                 您来到了月球，请返回…\n             ")]),_c('span',{on:{"click":function($event){return _vm.goback()}}},[_vm._v("返回")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }